function restorePlpSoldOutQuickAddLabels() {
  document.querySelectorAll('.quick-add__button--sold-out[data-plp-sold-out-label]').forEach(function (btn) {
    var label = btn.getAttribute('data-plp-sold-out-label');
    if (!label) return;
    var textEl = btn.querySelector('.btn__text');
    if (textEl) textEl.textContent = label;
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
  });
}

(function () {
  var DELAY_MS = 1000;
  var timer;

  function hideDrawerUtilitiesTemporarily() {
    document.documentElement.classList.add('drawer-utilities-delay-back');
    clearTimeout(timer);
    timer = setTimeout(function () {
      document.documentElement.classList.remove('drawer-utilities-delay-back');
    }, DELAY_MS);
  }

  window.addEventListener('pageshow', function (event) {
    var fromHistory = false;
    if (event.persisted) fromHistory = true;
    else {
      try {
        var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
        if (nav && nav.type === 'back_forward') fromHistory = true;
      } catch (e) {}
    }
    if (fromHistory) hideDrawerUtilitiesTemporarily();
  });

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest('header-drawer.drawer--header, mobile-menu')) return;
      if (!event.target.closest('[data-sliderule-close], .sliderow__back-button')) return;
      hideDrawerUtilitiesTemporarily();
    },
    true
  );
})();

document.addEventListener('DOMContentLoaded', function () {
  restorePlpSoldOutQuickAddLabels();
  window.addEventListener('gokwikLoaded', restorePlpSoldOutQuickAddLabels);
  setTimeout(restorePlpSoldOutQuickAddLabels, 500);
  setTimeout(restorePlpSoldOutQuickAddLabels, 2000);

  // Open popup when size pills under title are clicked
  document.body.addEventListener('click', function (event) {
    var pill = event.target.closest('.product-item__size-pill');
    if (!pill) return;

    // Prevent collection card navigation (anchor inside)
    event.preventDefault();
    event.stopPropagation();

    var sizesContainer = pill.closest('.product-item__sizes');
    if (!sizesContainer) return;

    var productId = sizesContainer.getAttribute('data-open-size-popup');
    if (!productId) return;

    var popup = document.querySelector('.plp-size-popup[data-size-popup="' + productId + '"]');
    if (!popup) return;

    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
  });

  // Close popup when clicking close button or backdrop
  document.body.addEventListener('click', function (event) {
    var closeBtn = event.target.closest('.plp-size-popup__close');
    var backdrop = event.target.classList.contains('plp-size-popup__backdrop') ? event.target : null;

    if (!closeBtn && !backdrop) return;

    var popup = closeBtn ? closeBtn.closest('.plp-size-popup') : backdrop.closest('.plp-size-popup');
    if (!popup) return;

    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
  });

  // Add to cart from popup and open cart drawer
  document.body.addEventListener('click', function (event) {
    var sizePill = event.target.closest('.plp-size-popup__pill');
    if (!sizePill) return;

    var variantId = sizePill.getAttribute('data-variant-id');
    if (!variantId) return;

    event.preventDefault();

    var addUrl =
      window.theme && window.theme.routes && window.theme.routes.cart_add_url
        ? window.theme.routes.cart_add_url + '.js'
        : '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (data.errors) {
            var msg =
              (data.description && String(data.description)) ||
              (data.message && String(data.message)) ||
              'Add to cart failed';
            throw new Error(msg);
          }
          if (!response.ok) {
            throw new Error('Add to cart failed');
          }
          return data;
        });
      })
      .then(function () {
        var popup = sizePill.closest('.plp-size-popup');
        if (popup) {
          popup.classList.remove('is-visible');
          popup.setAttribute('aria-hidden', 'true');
        }

        // Broadcast CartItems: refresh drawer HTML then theme dispatches theme:product:added → opens cart drawer
        document.dispatchEvent(
          new CustomEvent('theme:cart:refresh', {
            bubbles: true
          })
        );
      })
      .catch(function (error) {
        console.error(error);
      });
  });
});

/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
